module.exports = __webpack_public_path__ + "img/阿里云.eb447897.png";